import React, {useCallback} from "react";
import {Link, useHistory} from "react-router-dom";

const PageHeader = (props) => {
  const history = useHistory();

  const handleGoBack = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(props.goBackLink ?? "/");
    }
  }, [history, props.goBackLink]);

  return (
    <div className={`page-header-new${props.noMargin ? '' : ' mt-30 mb-20'}`}>
      <div
        onClick={handleGoBack}
        className="base-button icon-button evo-blue"
      >
        <span className="material-icons">chevron_left</span>
      </div>

      {props.extraActions && props.extraActions}

      <h2 className="page-title">{props.pageTitle}</h2>

      <div className="page-breadcrumb">
        {props.breadcrumbs.map(({label, link, isCurrentPage}) =>
          isCurrentPage ?
            <p className="current-page">{label}</p>
            : <>
              <Link to={link}>{label}</Link>
              <span className="material-icons">chevron_right</span>
            </>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
